(() => {
  const selector = 'script[data-site-release-state]';
  const node = document.querySelector(selector);
  if (!node) return;

  let current;
  try {
    current = JSON.parse(node.textContent);
  } catch {
    return;
  }

  const valid = state =>
    state &&
    typeof state.version === 'string' &&
    /^[a-zA-Z0-9._-]{1,80}$/.test(state.version) &&
    Number.isSafeInteger(state.themeId) &&
    state.themeId > 0;

  const pageUrl = new URL(window.location.href);
  if (!valid(current) || current.designMode ||
      pageUrl.searchParams.has('preview_theme_id') ||
      window.location.hostname.endsWith('.shopifypreview.com')) return;

  let checking = false;
  let lastCheck = -Infinity;
  let formEdited = false;
  let formSubmitted = false;
  let navigating = false;

  document.addEventListener('input', event => {
    if (event.isTrusted && event.target instanceof Element &&
        (event.target.closest('form') || event.target.isContentEditable)) {
      formEdited = true;
    }
  }, true);

  document.addEventListener('change', event => {
    if (event.isTrusted && event.target instanceof Element &&
        event.target.closest('form')) formEdited = true;
  }, true);

  document.addEventListener('submit', () => {
    formSubmitted = true;
  }, true);

  const safeToRefresh = () =>
    document.visibilityState === 'visible' &&
    !formEdited &&
    !formSubmitted &&
    !navigating &&
    !document.activeElement?.matches(
      'input, textarea, select, [contenteditable="true"], [contenteditable=""]'
    );

  async function checkRelease(force = false) {
    if (checking || navigating || document.visibilityState !== 'visible' ||
        navigator.onLine === false ||
        (!force && Date.now() - lastCheck < 60000)) return;

    checking = true;
    lastCheck = Date.now();
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 6000);

    try {
      const endpoint = new URL(current.root || '/', window.location.origin);
      if (endpoint.origin !== window.location.origin) return;
      endpoint.searchParams.set('section_id', 'site-release-status');
      endpoint.searchParams.set('_site_release_check', String(Date.now()));

      const response = await fetch(endpoint.href, {
        cache: 'no-store',
        credentials: 'same-origin',
        signal: controller.signal
      });
      if (!response.ok || new URL(response.url).origin !== window.location.origin) return;

      const html = await response.text();
      const result = new DOMParser().parseFromString(html, 'text/html');
      const freshNode = result.querySelector(selector);
      if (!freshNode) return;

      const fresh = JSON.parse(freshNode.textContent);
      if (!valid(fresh) || fresh.designMode) return;
      if (fresh.version === current.version && fresh.themeId === current.themeId) return;
      if (!safeToRefresh()) return;

      const target = new URL(window.location.href);
      if (target.searchParams.has('preview_theme_id')) return;

      const token = fresh.themeId + '-' + fresh.version;
      const attempt = target.pathname + '|' + token;
      if (target.searchParams.get('_site_release') === token) return;

      try {
        if (sessionStorage.getItem('utopia-site-release-attempt') === attempt) return;
        sessionStorage.setItem('utopia-site-release-attempt', attempt);
      } catch {
      }

      target.searchParams.set('_site_release', token);
      navigating = true;
      window.location.replace(target.href);
    } catch {
    } finally {
      window.clearTimeout(timeout);
      checking = false;
    }
  }

  window.addEventListener('pageshow', event => {
    if (event.persisted) checkRelease(true);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkRelease();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => checkRelease(), { once: true });
  } else {
    checkRelease();
  }
})();